import ApiService from '@zola-helpers/client/dist/es/http/api';
import * as ActionType from './types/PromoMessageActionTypes';

const requestedPromoMessage = () => ({
  type: ActionType.REQUEST_PROMO_MESSAGE,
});

const receivedPromoMessage = (response) => ({
  type: ActionType.RECEIVE_PROMO_MESSAGE,
  payload: response,
});

const requestPromoMessage = () => (dispatch) => {
  dispatch(requestedPromoMessage());
  return ApiService.get('/website-nav/web-api/v1/promoMessage').then((json) => {
    dispatch(receivedPromoMessage(json));

    return json;
  });
};

export default requestPromoMessage;
